import _ from "lodash";
import {Grid, Typography} from "@mui/material";
import {KeyValuePair} from "../base/KeyValuePair";
import {User} from "../../types/domain/user";
import {useTranslation} from "react-i18next";

export interface Props {
    user: User;
}

export const UserProfileCard: React.FC<Props> = ({user}) => {
    const {t} = useTranslation();
    return (
        <Grid container spacing={3}>
            <Grid item xs={6}>
                <KeyValuePair header={t("users.profile.firstname")}>
                    <Typography>{user.properties.firstName}</Typography>
                </KeyValuePair>
            </Grid>
            <Grid item xs={6}>
                <KeyValuePair header={t("users.profile.lastname")}>
                    <Typography>{user.properties.lastName}</Typography>
                </KeyValuePair>
            </Grid>
            <Grid item xs={6}>
                <KeyValuePair header={t("users.profile.email")}>
                    <Typography>{user.properties.email}</Typography>
                </KeyValuePair>
            </Grid>
            {user.properties.company && (
                <Grid item xs={6}>
                    <KeyValuePair header={t("users.profile.company")}>
                        <Typography>{user.properties.company}</Typography>
                    </KeyValuePair>
                </Grid>
            )}
            {user.properties.country && (
                <Grid item xs={6}>
                    <KeyValuePair header={t("users.profile.country")}>
                        <Typography>{user.properties.country}</Typography>
                    </KeyValuePair>
                </Grid>
            )}
            {user.properties.phone && (
                <Grid item xs={6}>
                    <KeyValuePair header={t("users.profile.phone")}>
                        <Typography>{user.properties.phone}</Typography>
                    </KeyValuePair>
                </Grid>
            )}
            <Grid item xs={12}>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <KeyValuePair header={t("users.profile.role")}>
                            <Typography>{_.capitalize(user.security.role)}</Typography>
                        </KeyValuePair>
                    </Grid>
                    <Grid item xs={6}>
                        <KeyValuePair header={t("users.profile.beta")}>
                            <Typography>
                                {user.security.attributes.betaFeatures ? t("users.profile.yes") : t("users.profile.no")}
                            </Typography>
                        </KeyValuePair>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
